exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mutabakat-report-table[data-v-7c9bd947]{width:100%;margin-top:4px}.mutabakat-report-table>*[data-v-7c9bd947]{width:100%}.mutabakat-action-cell[data-v-7c9bd947]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
